enum PlayModes {
  PERCEPTION = "PERCEPTION",
  AWARENESS = "AWARENESS",
  DEFENSIVE = "DEFENSIVE",
  TRAINING = "TRAINING",
  INHIBITION = "INHIBITION",
  REPLAY = "REPLAY",
  STRATEGY = "STRATEGY",
};

export default PlayModes;